var _rect, _rect2, _rect3, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333008,
    y: 0.5,
    width: 19,
    height: 18,
    rx: 5,
    fill: "#66DEB2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.333008,
    y: 0.5,
    width: 19,
    height: 18,
    rx: 5,
    fill: "#E41E42"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.333008,
    y: 0.5,
    width: 19,
    height: 18,
    rx: 5,
    fill: "#464C50"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_870_34849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33301 6H14.333",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.96973 9.5L12.697 9.5",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.19629 13H11.469",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_870_34849"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 10,
    fill: "white",
    transform: "translate(4.33301 4.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterGray);
export default __webpack_public_path__ + "static/media/FilterGray.40faa2e3b7f9bb30b02e3c9748da3a1d.svg";
export { ForwardRef as ReactComponent };